<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <div class="pa-5 mb-5">
                <h2>Password</h2>
                <p class="mb-0">*Minimum of 8 characters with at least 1 uppercase, 1 lowercase and 1 digit.*</p>
            </div>
            <v-row>
                <v-col cols="12" md="8">
                    <v-form class="pl-5 pr-5 mb-5" ref="form">
                        <label for="">Enter Old Password</label>
                        <v-text-field :rules="passwordRules" :type="show ? 'text' : 'password'" class="pass-input" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show" v-model="password" required color="auto" outlined></v-text-field>
                        <label for="">Enter New Password</label>
                        <v-text-field :type="show1 ? 'text' : 'password'" class="pass-input" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show1 = !show1" v-model="newpassword" :rules="newpasswordRules" required color="auto" outlined></v-text-field>
                        <label for="">Confirm Password</label>
                        <v-text-field :rules="cnewpasswordRules.concat(passwordConfirmationRule)" class="pass-input" type="password" v-model="cnewpassword" required color="auto" outlined></v-text-field>
                        <br>
                        <default-button :loading="loading" :disabled="!isComplete" @click="validateForm">Change Password</default-button>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
// ============= IMPORT COMPONENTS ===========
import DefaultButton from "@/components/Buttons/default-button.vue";

// ========== IMPORT SERVICES =========
import { AdminService } from "@/services";

export default {
    data : () => ({
        password : '',
        show1:false,
        show:false, 
        newpassword : '',
        cnewpassword : '',
        loading:false,
        passwordRules: [
            (v) => !!v || "This field is required",
            
        ],
        newpasswordRules:[
            (v) => !!v || "This field is required",
            (v) =>
                /^^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#-])[A-Za-z\d@$!%*?&#-]{8,}$/.test(
                v
                ) ||
                "minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:",
        ],
        cnewpasswordRules:[
            (v) => !!v || "This field is required",
            
        ]

    }),
    components:{
        DefaultButton
    },
    computed:{
        isComplete(){
            return this.password && this.newpassword && this.cnewpassword
        },
        passwordConfirmationRule() {
            return () => this.newpassword === this.cnewpassword || "Password must match";
        }
    },
    methods:{
        validateForm(){
            if(this.$refs.form.validate()){
                this.changePassword();
            }
        },
        async changePassword(){
            try {
                this.loading = true
                let payload = {
                    password:this.password,
                    newpassword:this.newpassword,
                    cnewpassword : this.cnewpassword
                }
                const data = await AdminService.changePassword(payload);
                this.$store.dispatch("toast", {
                    message: data.message,
                    variant: "success",
                });
                this.newpassword = '';
                this.cnewpassword = '';
                this.password = '';
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error);
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>